export default [
  {
    id: 17823,
    name: 'Garage',
    description: '',
    type: 2,
    groupId: 17823,
    categoryId: '1349',
    media: {
      src: 'https://d1ryu1giyrwia8.cloudfront.net/17757/MLv3/15/51/2023/09/14/100243/65032ea3876f98.90142620422.webp',
      caption: 'Screenshot 2023-09-14 at 10.00.45 AM',
      name: '',
      description: '',
      format: '',
      width: 0,
      height: 0,
      fullsizeUri: '',
      thumbnailUri: '',
      isDefault: false,
    },
    monthlyRate: 0,
    addOnOptions: [
      {
        id: 3,
        groupId: 17823,
        name: 'Garage lot 21',
        rates: [
          {
            charge: 501,
            frequency: 'Monthly',
            type: 'Other income',
          },
        ],
      },
      {
        id: 4,
        groupId: 17823,
        name: 'Garage lot 34',
        rates: [
          {
            charge: 50,
            frequency: 'Monthly',
            type: 'Other income',
          },
        ],
      },
    ],
  },
  {
    id: 1,
    name: 'Rent Credit Reporting',
    description: '',
    type: '1',
    groupId: 80109,
    categoryId: 1020,
    media: null,
    rates: [
      {
        charge: 14,
        frequency: 'Monthly',
        type: 'Other income',
      },
    ],
    addOnOptions: [],
  },
  {
    id: 5,
    name: 'Treadmill in Unit',
    description: '',
    type: '2',
    groupId: 80060,
    categoryId: 1017,
    media: null,
    rates: [
      {
        charge: 12,
        frequency: 'Monthly',
        type: 'Other income',
      },
    ],
    addOnOptions: [],
  },
  {
    id: 6,
    name: 'Fitness Room Key',
    description: '',
    type: '3',
    groupId: 81472,
    categoryId: 1023,
    media: null,
    rates: [
      {
        charge: 5,
        frequency: 'Monthly',
        type: 'Other income',
      },
    ],
    addOnOptions: [],
  },
  {
    id: 7,
    name: 'Parking Pass',
    description: '',
    type: '3',
    groupId: 81613,
    categoryId: 1020,
    media: null,
    rates: [
      {
        charge: 8,
        frequency: 'Monthly',
        type: 'Other income',
      },
    ],
    addOnOptions: [],
  },
];
